(function () {
  if (window.__cascabelTermsLoaded) return;
  window.__cascabelTermsLoaded = true;

  function findLinkDeep(root = document) {
    const link = root.querySelector('a[title="términos y condiciones"]');
    if (link) return link;
    for (const el of root.querySelectorAll('*')) {
      if (el.shadowRoot) {
        const found = findLinkDeep(el.shadowRoot);
        if (found) return found;
      }
    }
    return null;
  }

  function inject() {
    const link = findLinkDeep();
    if (!link) return false;

    const p = link.closest('p');
    if (!p || p.querySelector('#cascabel-terms-checkbox')) return !!p;

    const cb = document.createElement('input');
    cb.type = 'checkbox';
    cb.id = 'cascabel-terms-checkbox';
    cb.required = true;
    cb.style.cssText = 'margin:0 8px 0 0;width:16px;height:16px;accent-color:#9CB49D;cursor:pointer;flex-shrink:0;';

    p.style.cssText += 'display:flex;align-items:center;flex-wrap:wrap;gap:2px;';
    p.insertBefore(cb, p.firstChild);

    const form = p.getRootNode().querySelector('form[data-testid="form"]');
    const btn = form?.querySelector('[data-testid="btn-form-submit"]');

    function lock(disabled) {
      if (!btn) return;
      btn.disabled = disabled;
      btn.style.opacity = disabled ? '.4' : '';
      btn.style.pointerEvents = disabled ? 'none' : '';
    }
    lock(true);
    cb.addEventListener('change', () => lock(!cb.checked));

    form?.addEventListener('submit', (e) => {
      if (!cb.checked) {
        e.preventDefault();
        e.stopImmediatePropagation();
        cb.reportValidity();
      }
    }, true);

    return true;
  }

  function go() {
    if (inject()) return;
    const obs = new MutationObserver(() => { if (inject()) obs.disconnect(); });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => obs.disconnect(), 30000);
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', go)
    : go();
})();